<template>
<metainfo>
</metainfo>
  <v-app color="white">
    <router-view/>
  </v-app>
</template>

<script>

export default {
  name: "App",
   created() {
    try{
    let recaptchaInterval = null;
    recaptchaInterval = setInterval(() => {
      let recaptchaBadge = document.getElementsByClassName("grecaptcha-badge");
      if (recaptchaBadge && recaptchaBadge.length && recaptchaBadge[0].style) {
        recaptchaBadge[0].style.display = "none";
        clearInterval(recaptchaInterval);
      }
    }, 100);
    }
    catch(error){
      console.error("recpatcha hide error",error)
    }
  },
};
</script>
 <style src="./styles/_app.scss" lang="scss" />


